export enum LorenBinaryConditionEnum {
  STATE_ON = "STATE_ON",
  STATE_OFF = "STATE_OFF",
  BINARY_IS_OPEN = "BINARY_IS_OPEN",
  BINARY_IS_CLOSED = "BINARY_IS_CLOSED",
  IGNITION_TRUE = "IGNITION_TRUE",
  IGNITION_FALSE = "IGNITION_FALSE",
  WATER_LEAK_TRUE = "WATER_LEAK_TRUE",
  WATER_LEAK_FALSE = "WATER_LEAK_FALSE",
  LIGHT_IS_BRIGHT = "LIGHT_IS_BRIGHT",
  LIGHT_IS_DARK = "LIGHT_IS_DARK",
  MOVEMENT_START = "MOVEMENT_START",
  MOVEMENT_STOP = "MOVEMENT_STOP",
  SMOKE_TRUE = "SMOKE_TRUE",
  SMOKE_FALSE = "SMOKE_FALSE",
  TILT_FALSE = "TILT_FALSE",
  TILT_TRUE = "TILT_TRUE",
}
